// extracted by mini-css-extract-plugin
module.exports = {"benefits-container":"Benefits_benefits-container__xTOvH","benefit-modal-wrapper":"Benefits_benefit-modal-wrapper__ZKHoj"};